export const defaultFaq = [
    {
        question: "Is house sitting safe?",
        answer: "Yes, house sitting is safe when arranged through trusted platforms like HouseSit Match. These platforms often verify user profiles, ensuring a secure and trustworthy experience for both parties.",
    },
    {
        question: "Do house sitters get paid?",
        answer: "While most house-sitting arrangements are unpaid, some homeowners offer payment for sitters who take on additional responsibilities, such as caring for multiple pets or handling extensive maintenance tasks. However, as a general rule no money should change hands.",
    },
    {
        question: "Can families house sit together?",
        answer: "Absolutely! Many assignments are suitable for families, though it's important to communicate this upfront to ensure the arrangement meets the homeowner's expectations.",
    },
    {
        question: "Do I need insurance for house sitting?",
        answer: "Depending on the arrangement, both homeowners and house sitters might consider insurance for added peace of mind. Property owners should verify that their home insurance policy covers house sitters, while sitters may opt for liability insurance to protect against accidental damages. Homeowners should also note that home insurers do not like a property to be left empty for more than 30 days.",
    },
    {
        question: "Can house sitting include caring for exotic pets?",
        answer: "Yes, many homeowners with exotic pets, such as reptiles or birds, seek experienced house sitters. Sitters should confirm they are comfortable and knowledgeable about the specific care requirements before committing.",
    },
];